import { Label } from "@logora/parliament.ui.label";

export function EtatLabel({ etat, style, className }) {
	const colorVariants = {
		success: ["Confirmé", "Terminé"],
		info: "À venir",
		cancel: ["Annulé", "Supprimé"],
		neutral: "Eventuel",
	};

	return (
		<Label
			text={etat.charAt(0).toUpperCase() + etat.slice(1)}
			variantsObject={colorVariants}
			colorType={etat}
			style={style}
			className={className}
		/>
	);
}
